import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/progress-failed.png'
import _imports_1 from '@/assets/image/import-loading.png'
import _imports_2 from '@/assets/image/progress-success.png'
import _imports_3 from '@/assets/image/import-close.png'
import _imports_4 from '@/assets/image/import-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1e9330cf")

_pushScopeId("data-v-1e9330cf")
const _hoisted_1 = { class: "import" }
const _hoisted_2 = { class: "header display-flex justify-content-between" }
const _hoisted_3 = { class: "loading-content display-flex align-items-center" }
const _hoisted_4 = { class: "import-title" }
const _hoisted_5 = { class: "margin-left5px import-title" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "margin-left25px"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "margin-left25px rotate"
}
const _hoisted_8 = { class: "import-title" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  class: "margin-left25px"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_2,
  class: "margin-left25px"
}
const _hoisted_11 = { class: "arrow-content display-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_13 = { class: "import-item-msg" }
const _hoisted_14 = { class: "display-flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_import_progress = _resolveComponent("import-progress")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_error_dialog = _resolveComponent("error-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.details.Finished != _ctx.details.Details.length)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$wordList.ProperAllTextImporting), 1),
              _createVNode("p", _hoisted_5, _toDisplayString(_ctx.details.Finished) + "/" + _toDisplayString(_ctx.details.Details.length), 1),
              (_ctx.isFailed)
                ? (_openBlock(), _createBlock("img", _hoisted_6))
                : (_openBlock(), _createBlock("img", _hoisted_7))
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$wordList.ImportComplete), 1),
              (_ctx.isFailed)
                ? (_openBlock(), _createBlock("img", _hoisted_9))
                : (_ctx.isSuccess)
                  ? (_openBlock(), _createBlock("img", _hoisted_10))
                  : _createCommentVNode("", true)
            ], 64))
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("img", {
          src: require(_ctx.unfold?'@/assets/image/import-unfold.png':'@/assets/image/import-fold.png'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unfold=!_ctx.unfold))
        }, null, 8, ["src"]),
        _createVNode("img", {
          src: _imports_3,
          class: "margin-left25px",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        })
      ])
    ]),
    _createVNode(_component_el_scrollbar, null, {
      default: _withId(() => [
        _createVNode("ul", {
          class: "import-content",
          style: {height: _ctx.unfold ? '0px' : _ctx.contentHeight + 'px'},
          ref: "ulRef"
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details.Details, (item) => {
            return (_openBlock(), _createBlock("li", {
              class: "import-item display-flex align-items-center",
              key: item.UUID
            }, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode("p", null, _toDisplayString(item.Name), 1),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_import_progress, {
                    percent: item.Progress,
                    status: item.ProgressStatus===0?'failed':'success'
                  }, null, 8, ["percent", "status"]),
                  _withDirectives(_createVNode("div", {
                    class: "error-detail",
                    onClick: ($event: any) => (_ctx.showError(item.ErrorDetail, item.UUID))
                  }, _toDisplayString(_ctx.$wordList.Details), 9, ["onClick"]), [
                    [_vShow, item.Progress==100 && item.ProgressStatus==0]
                  ])
                ])
              ])
            ]))
          }), 128))
        ], 4)
      ]),
      _: 1
    }),
    (_ctx.isShowErrorDialog)
      ? (_openBlock(), _createBlock(_component_error_dialog, {
          key: 0,
          details: _ctx.errorDetails,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowErrorDialog=false))
        }, null, 8, ["details"]))
      : _createCommentVNode("", true)
  ]))
})